// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { compose } from '../../../../node_module_clones/recompose';

// Utils
import { getLineHandleMode } from '../utils/lineHandleUtil';

// Selectors
import { getElementId, getColourHex, isElementSelectedSelector } from '../../selectors/elementSelector';
import { getUpdatedLinePointsOfInterest } from '../lineControlPointSelector';
import {
    getLineStartStyleSelector,
    getLineEndStyleSelector,
    getIsLineStartSnappedSelector,
    getIsLineEndSnappedSelector,
} from '../lineSelector';

// Components
import Line from '../Line';

// Measurements
import measurementsConnect from '../../../components/measurementsStore/measurementsConnect';
import { getShallowMeasurementsMap } from '../../../components/measurementsStore/elementMeasurements/elementMeasurementsSelector';

// PERF: Don't need to connect to the specific measurements here, because they shouldn't change during the drag
const mapMeasurementsStateToProps = (connectionsState) => ({
    measurements: getShallowMeasurementsMap(connectionsState),
});

const mapStateToProps = createSelector(
    getElementId,
    isElementSelectedSelector(),
    getUpdatedLinePointsOfInterest,
    getColourHex(),
    getLineStartStyleSelector,
    getLineEndStyleSelector,
    getIsLineStartSnappedSelector,
    getIsLineEndSnappedSelector,
    (elementId, isSelected, lineDetails, colorHex, startStyle, endStyle, startSnapped, endSnapped) => ({
        elementId,
        isSelected,
        ...lineDetails,
        colorHex,
        startStyle,
        endStyle,
        startHandleMode: getLineHandleMode({ snapped: startSnapped }),
        endHandleMode: getLineHandleMode({ snapped: endSnapped }),
    }),
);

const enhance = compose(measurementsConnect(mapMeasurementsStateToProps), connect(mapStateToProps));

const LineControlPointDragPreview = (props) => (
    <Line {...props} showEndGhost showStartGhost controlHandleMode="dragging" isPresentational />
);

LineControlPointDragPreview.propTypes = {
    elementId: PropTypes.string.isRequired,
    offsetDiff: PropTypes.object,
};

export default enhance(LineControlPointDragPreview);
